const VERSION = "7.1.0";
export {
  VERSION
};
